import { lazy } from 'react';

import { renderRoutesFromArray } from './renderRoutesFromArray';

const Settings = lazy(() => import('../screens/main/settings'));
const SettingsPushes = lazy(() => import('../screens/main/settings-pushes'));
const MyProfile = lazy(() => import('../screens/main/my-profile'));
const MyProfilePersonal = lazy(() => import('../screens/main/my-profile/personal'));
const MyProfileAdditional = lazy(() => import('../screens/main/my-profile/additional'));
const MyProfileProfession = lazy(() => import('../screens/main/my-profile/profession'));
const MyProfileNetwork = lazy(() => import('../screens/main/my-profile/network'));
const Notifications = lazy(() => import('../screens/main/notifications'));
const CtaSubscription = lazy(() => import('../screens/main/cta-subscription'));
const ActivateCode = lazy(() => import('../screens/main/activate-code'));

const routeDefinitions = [
  {
    path: '/settings',
    element: <Settings />,
  },
  {
    path: '/settings/pushes',
    element: <SettingsPushes />,
  },
  {
    path: '/my-profile',
    element: <MyProfile />,
  },
  {
    path: '/my-profile/personal',
    element: <MyProfilePersonal />,
  },
  {
    path: '/my-profile/additional',
    element: <MyProfileAdditional />,
  },
  {
    path: '/my-profile/profession/:professionType',
    element: <MyProfileProfession />,
  },
  {
    path: '/my-profile/network',
    element: <MyProfileNetwork />,
  },
  {
    path: '/notifications',
    element: <Notifications />,
  },
  {
    path: '/notifications/is-humeo-like',
    element: <CtaSubscription />,
  },
  {
    path: '/activate-code',
    element: <ActivateCode />,
  },
];

const profileRoutes = renderRoutesFromArray(routeDefinitions);
export default profileRoutes;
